import { init as initApm } from '@elastic/apm-rum';
import invariant from 'invariant';
const getInvariantMessage = (key)=>`Trying to initialize APM client without ${key}`;
export const initApmWithAccessToken = (getAccessToken, apmOptions)=>{
    invariant(apmOptions.serverUrl, getInvariantMessage('serverUrl'));
    invariant(apmOptions.environment, getInvariantMessage('environment'));
    invariant(apmOptions.serviceName, getInvariantMessage('serviceName'));
    return initApm({
        apmRequest ({ xhr }) {
            const accessToken = getAccessToken?.();
            if (accessToken) {
                xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
            }
            return true;
        },
        ...apmOptions
    });
};
